import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CostDetailsComponent} from 'src/app/main/cost-mgmt/cost-details/cost-details.component';
import {ToolbarButton} from '../../../models/toolbar-button/toolbar-button';


const routes: Routes = [
  {
    path: '',
    component: CostDetailsComponent,
    data: {
      activeLink: ToolbarButton.COST_MGMT
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CostDetailsRoutingModule {
}
